import { render, staticRenderFns } from "./StoreType.vue?vue&type=template&id=486ee751"
import script from "./StoreType.vue?vue&type=script&lang=js"
export * from "./StoreType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports